export default __webpack_public_path__ + "static/media/demographics-mapping.b0e165a1.png";